// extracted by mini-css-extract-plugin
export default {"container":"UserSafeZones_container__-+vF-","map":"UserSafeZones_map__ArfgU","message":"UserSafeZones_message__vUGYh","header":"UserSafeZones_header__3TkJk"};